var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowForward18Line = function SvgIconArrowForward18Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.975 10.95-5.32-5.065-1.175 1.23 4.235 4.035H5.575v1.7H16.72l-4.235 4.035 1.175 1.23 5.32-5.065c.285-.27.45-.655.45-1.05s-.165-.78-.45-1.05h-.005Z",
    fill: "current"
  })));
};
export default SvgIconArrowForward18Line;